import { SET_CHALLENGE_STEPS } from '../../ActionTypes'

export const setChallengeStep = (step, challenge) => ({
  type: SET_CHALLENGE_STEPS,
  step,
  challenge,
})
